module.exports = "/images/trec-preview-1.jpg?c4d0291908200c5510589c1eb3a8d7d7";